import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { Image } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';


function MyNavbar() {
    const location = useLocation();
  return (
    <Navbar expand="lg" className="bg-body-tertiary">
      <Container fluid='lg'>
        <Navbar.Brand href="/"><Image src="/man_logo.svg" className='d-inline-block navbar-logo' /></Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav" className='justify-content-end'>
          <Nav activeKey={location.pathname} className="ml-auto">
            <Nav.Link exact href="/">Startseite</Nav.Link>
            <Nav.Link href="/leistungen">Leistungen</Nav.Link>
            <Nav.Link href="/career">Karriere</Nav.Link>
            <Nav.Link href="/about">Über uns</Nav.Link>
            <Nav.Link href="/kontakt">Kontakt</Nav.Link>
            <Nav.Link href="/partner">Partner & Links</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default MyNavbar;